module.exports = __webpack_public_path__ + "img/exam1.01261d83.png";